import { Resource as i, API as o } from "@coveo/platform-client";
const s = class s extends i {
  preview(e, a, r) {
    return this.api.post(
      this.buildPath(`${s.baseUrl}/new`, {
        trackingId: a,
        ...r ? { id: r } : {}
      }),
      e
    );
  }
};
s.baseUrl = `/rest/organizations/${o.orgPlaceholder}/commerce/v2/search/preview/synonyms`;
let t = s;
export {
  t as SynonymRulePreview
};
//# sourceMappingURL=SynonymRulePreview.js.map
